import styled from 'styled-components';

export const ForYouContainer = styled.div`
  text-align: center;
  padding-top: 25px;
  .promiseImage {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 5px;
    img {
      width: 7%;
    }

    @media (max-width: 720px) {
      img {
        width: 20%;
      }
    }
  }
  .heading1 {
    font-size: clamp(22px, 2vw, 42px);
    font-weight: 600;
    color: #675b5a;
  }
  .heading2 {
    font-size: clamp(22px, 2vw, 42px);
    font-weight: 600;
    color: #7e5c5c;
  }
  .innerSection {
    display: flex;
    padding: 25px 15% 0;
    @media (max-width: 720px) {
      padding: 0px 12px 0;
      align-items: unset;
    }
    justify-content: space-between;
    align-items: center;
    .imageAndText {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      width: 25%;

      p {
        font-size: clamp(14px, 2vw, 24px);
        color: #6e6e6e;
        font-weight: 500;
      }
      .subText {
        color: #7e5c5c;
      }
      @media (max-width: 720px) {
        width: 28%;
        padding-top: 24px;
        gap: 0;
      }
    }

    .imageBackground {
      border-radius: 12px;
      //  background-color: #f9f0db;
      width: max-content;
      img {
        width: 64px;
      }
      @media (max-width: 720px) {
        padding: 6px;
        img {
          width: 45px;
        }
      }
    }
  }
`;
